import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {ActivityTabs} from "../enums/activity-tabs";
import {Team} from "../interface/team";

@Injectable({
  providedIn: 'root'
})
export class ActivityFactory {
  public static isIndividualActive: BehaviorSubject<string> = new BehaviorSubject<string>(ActivityTabs.ALL_INDIVIDUAL);
  public static isIndividualActiveInSight: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public static selectedTeam: BehaviorSubject<Team | null> = new BehaviorSubject<Team | null>(null);
  public static currentTeam: BehaviorSubject<Team | null> = new BehaviorSubject<Team | null>(null);
}
